import React, { useEffect, useState, useRef } from "react"

import { FormControl, FormLabel, Select, Option } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";
import InputTextElement from "./InputTextElement";
import { useTranslation } from 'react-i18next';
import { useFormatter } from "../../utils";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { useSelectOptions } from "src/mtska-frontend-app-component/utils/SelectOptions";
import { debounce } from 'lodash';

const InputRuleEditorControl = ({ item, editing, required, name, control, autoFocus, placeholder, type = "text", hint, icon, haserror, disabled, readonly, relation, className = "" }) => {
    const { t } = useTranslation();
    const { getSelectOptions } = useSelectOptions();
    const { item: config } = useDataProvider('configs/config');

    const { doAction } = useDataProvider(relation.dataProviderName);

    if (!editing) readonly = true;

    const columnsRendered = useRef();

    const isFirstLoad = useRef(true);

    const [fieldOptions, setFieldOptions] = useState();
    const [operatorOptions, setOperatorOptions] = useState();
    const [valueOptions, setValueOptions] = useState();

    const [field, setField] = useState();
    const [operator, setOperator] = useState();
    const [value, setValue] = useState();

    const lastSubmittedRef = useRef({});

    const saveRule = useRef(
        debounce((current) => {
            if (JSON.stringify(current) === JSON.stringify(lastSubmittedRef.current)) return;
            lastSubmittedRef.current = current;
            
            doAction({
                action: 'create',
                model: relation.dataProviderName,
                data: { id: item._id, ...current }
            });
        }, 500)
    ).current;

    useEffect(() => {
        if (!relation) return;

        columnsRendered.current = config.data.modules[relation.tableProviderName].tableConfig.columnsRendered;
        const fieldOptions = getSelectOptions(relation.recipe)
        setFieldOptions(fieldOptions)
    }, [relation])

    useEffect(() => {
        handleFieldChange(item.field);
        handleOperatorChange(item.operator);
        handleValueChange(item.value);

        setTimeout(() => {
            isFirstLoad.current = false;
        }, 100);
    }, [item]);

    const handleFieldChange = (v) => {
        const valueOptions = columnsRendered.current[v];

        if (valueOptions?.options) {
            setOperatorOptions(getSelectOptions(['equals', 'doesNotEqual']));
            setValueOptions(getSelectOptions(valueOptions.options));
        } else {
            setOperatorOptions(
                getSelectOptions([
                    'contains',
                    'equals',
                    'doesNotEqual',
                    'startsWith',
                    'endsWith',
                    'isEmpty',
                    'isNotEmpty',
                    'isAnyOf',
                    '>',
                    '>=',
                    '<',
                    '<='
                ])
            );
            setValueOptions(null);
        }

        setField(v);
    }

    const handleOperatorChange = (v) => {
        setOperator(v);
    }

    const handleValueChange = (v) => {
        setValue(v);
    }

    useEffect(() => {
        if (!isFirstLoad.current) {
            saveRule({ field, operator, value });
        }
    }, [field, operator, value]);

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value: formValue, name },
                fieldState: { error, invalid },
                formState,
            }) => {

                if (typeof formValue == typeof undefined) {
                    className = className.replace(' filled', '').replace(' empty', '') + ' empty';
                } else {
                    className = className.replace(' filled', '').replace(' empty', '') + ' filled';
                }

                let outerClass = "form-element-control";
                outerClass += (editing) ? " editing" : " reading";
                outerClass += (error) ? " error" : "";
                outerClass += (required) ? " required" : "";
                outerClass += (disabled) ? " disabled" : "";

                return (
                    <>
                        <div className={("form-element select col-4").trim()}>
                            <FormControl error={invalid} className={(error) ? outerClass + " form-element-error" : outerClass}>
                                <FormLabel className="form-element-label" htmlFor={'field'}>{t('field')}</FormLabel>
                                <Select
                                    id={'field'}
                                    name={'field'}
                                    value={field}
                                    error={invalid}
                                    onChange={(e, v) => {
                                        //onChange(v);
                                        handleFieldChange(v)
                                    }}
                                    variant="outlined"
                                    autoComplete="off"
                                    className="form-element-field form-element-field-select"

                                    autoFocus={autoFocus}
                                    placeholder={t(placeholder)}
                                    disabled={disabled}
                                    readOnly={readonly}
                                    required={required}
                                >
                                    <Option value="">Select</Option>
                                    {fieldOptions}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={("form-element select col-4").trim()}>
                            <FormControl error={invalid} className={(error) ? outerClass + " form-element-error" : outerClass}>
                                <FormLabel className="form-element-label" htmlFor={'operator'}>{t('operator')}</FormLabel>
                                <Select
                                    id={'operator'}
                                    name={'operator'}
                                    value={operator}
                                    error={invalid}
                                    onChange={(e, v) => {
                                        //onChange(v);
                                        handleOperatorChange(v)
                                    }}
                                    variant="outlined"
                                    autoComplete="off"
                                    className="form-element-field form-element-field-select"

                                    autoFocus={autoFocus}
                                    placeholder={t(placeholder)}
                                    disabled={disabled || !operatorOptions}
                                    readOnly={readonly || !operatorOptions}
                                    required={required}
                                >
                                    <Option value="">Select</Option>
                                    {operatorOptions}
                                </Select>
                            </FormControl>
                        </div>

                        {
                            !valueOptions ?
                                <InputTextElement
                                    id={'value'}
                                    name={'value'}
                                    value={value}
                                    type={type}
                                    label={'value'}
                                    placeholder={placeholder}
                                    icon={icon}
                                    hint={hint}

                                    error={error}
                                    invalid={(error) ? invalid : haserror}
                                    editing={editing}
                                    required={required}
                                    autoFocus={autoFocus}
                                    disabled={disabled || !operatorOptions}
                                    readonly={readonly || !operatorOptions}

                                    className={'col-4'}
                                    onChange={(e, v) => {
                                        console.info('effettuo onChange di field', e.target.value)
                                        //onChange(v);
                                        handleValueChange(e.target.value)
                                    }}
                                />
                                :
                                <div className={("form-element select col-4").trim()}>
                                    <FormControl error={invalid} className={(error) ? outerClass + " form-element-error" : outerClass}>
                                        <FormLabel className="form-element-label" htmlFor={'value'}>{t('value')}</FormLabel>
                                        <Select
                                            id={'value'}
                                            name={'value'}
                                            value={value}
                                            error={invalid}
                                            onChange={(e, v) => {
                                                //onChange(v);
                                                handleValueChange(v)
                                            }}
                                            variant="outlined"
                                            autoComplete="off"
                                            className="form-element-field form-element-field-select"

                                            autoFocus={autoFocus}
                                            placeholder={t(placeholder)}
                                            disabled={disabled || !operatorOptions}
                                            readOnly={readonly || !operatorOptions}
                                            required={required}
                                        >
                                            <Option value="">Select</Option>
                                            {valueOptions}
                                        </Select>
                                    </FormControl>
                                </div>
                        }

                    </>
                )
            }}
        />
    );
};

export default InputRuleEditorControl;
